---
title: Updates
lede: Airlock downloads new versions by itself and installs them when you click.
order: 50
part: Teams and settings
---

Airlock checks for a new version 30 seconds after it starts, then every six hours, and downloads it in the background. Nothing installs until you click: an update replaces the app bundle. **Check for updates…** in the Airlock menu checks now.

### The update chip

A chip beside **Search** in the window bar shows progress. When there is nothing to say, there is no chip.

| Chip | What it means |
|---|---|
| **Checking for updates…** | A check you asked for is running |
| **Downloading** *version* | The new version is downloading, with a percentage |
| **Close** *N* **sessions** | It is ready, but sessions still hold a micro-VM. Click to close the first one, after its confirmation |
| **Restart to update** | It is ready. Click to install and restart |
| **Restarting…** | The new version is being installed |
| **Update check failed** | A check you asked for could not reach the update service, or your key was refused. It clears after a few seconds |

**Restart to update** is green and **Close** *N* **sessions** is amber: they are the only chips that want a click. Hover either first: it says what the click costs.

### Sessions hold an update back

A new version installs only once no session holds a micro-VM: running, parked or waiting for review. Close each one, and merge first what you want to keep, since a closed session's machine and unmerged work are gone. A session that runs [on this computer](/placement) holds nothing back, but restarting stops its agent mid-run, so restart when nothing is working.

### Your key

Updates need a licence key, sent with each check together with a fingerprint of this computer. Without a key, or after **Access until** has passed, Airlock keeps working but stops updating. A key you store is used at the next check. See [Your licence key](/licence).

**Settings › License** shows **Last check** and, when it was refused, a **Detail** saying why. Every check is logged in `updater.log` in the [data folder](/data-folder).

### Which version you have

**Settings › About**, or **About Airlock** in the Airlock menu. Quote the whole page when you write to [support@tryairlock.app](mailto:support@tryairlock.app).

![The About page](media/settings-about.webp)
